<template>
  <div class="workbench-container">
    <!-- 顶部导航栏和背景 -->
    <div class="top-background">
      <img
        src="../assets/img/home/home-top.png"
        alt="背景"
        class="background-img"
      />
      <userShopInfo
        :we-com-user-info="weComUserInfo"
        :departmentdata="departmentdata"
      ></userShopInfo>
      <!-- 数据概览区域 -->
      <div class="data-overview">
        <div class="data-item">
          <div class="data-number">988</div>
          <div class="data-label">
            <div class="data-label-text">
              我的客户
              <div class="data-badge"></div>
            </div>
          </div>
        </div>
        <div class="data-item">
          <div class="data-number">4839</div>
          <div class="data-label">成交金额</div>
        </div>
        <div class="data-item">
          <div class="data-number">323</div>
          <div class="data-label">退款金额</div>
        </div>
      </div>
    </div>
    <div class="function-box" v-if="!roledata">
      <div class="role_container">
        <img src="../assets/img/home/workrole.png" alt="" />
        <div class="function-label">请联系管理员开通权限</div>
      </div>
    </div>
    <div class="function-box" v-else>
      <!-- 操作区域 -->
      <div class="function-section">
        <div class="section-header">
          <span class="section-title">操作</span>
        </div>
        <div class="function-grid">
          <div
            class="function-item"
            @click="navigateToPage('/invite-customers')"
            style="cursor: pointer"
          >
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-1.png"
                alt="邀请客户"
                class="icon-img"
              />
            </div>
            <div class="function-label">邀请客户</div>
          </div>
          <div
            class="function-item"
            @click="navigateToPage('/write-off')"
            style="cursor: pointer"
          >
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-2.png"
                alt="核销"
                class="icon-img"
              />
            </div>
            <div class="function-label">核销</div>
          </div>
          <div
            class="function-item"
            @click="navigateToPage('/shopcheckin')"
            style="cursor: pointer"
          >
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-3.png"
                alt="签到"
                class="icon-img"
              />
            </div>
            <div class="function-label">签到</div>
          </div>
          <div
            class="function-item"
            @click="navigateToPage('/BuyerProxyPayment')"
            style="cursor: pointer"
          >
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-4.png"
                alt="代客下单"
                class="icon-img"
              />
            </div>
            <div class="function-label">代客下单</div>
          </div>
        </div>
      </div>

      <!-- 交易区域 -->
      <div class="function-section">
        <div class="section-header">
          <span class="section-title">交易</span>
          <span class="view-all" @click="navigateToPage('/orderlist')"
            >全部订单
            <img src="../assets/img/home/ico-19.png" class="viwe-arrow" alt=""
          /></span>
        </div>
        <div class="function-grid transaction-grid">
          <div class="function-item">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-5.png"
                alt="待付款"
                class="icon-img"
              />
            </div>
            <div class="function-label">待付款</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-6.png"
                alt="待发货/自提"
                class="icon-img"
              />
            </div>
            <div class="function-label">待发货/自提</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-7.png"
                alt="退货/退款"
                class="icon-img"
              />
            </div>
            <div class="function-label">退货/退款</div>
          </div>
        </div>
      </div>

      <!-- 运营区域 -->
      <div class="function-section">
        <div class="section-header">
          <span class="section-title">运营</span>
        </div>
        <div class="function-grid">
          <div class="function-item" @click="navigateToPage('/activity')">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-8.png"
                alt="活动"
                class="icon-img"
              />
            </div>
            <div class="function-label">活动</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-9.png"
                alt="复购提醒"
                class="icon-img"
              />
            </div>
            <div class="function-badge">1</div>
            <div class="function-label">复购提醒</div>
          </div>
          <div class="function-item" @click="navigateToPage('/xxxxxxxxxxxx')">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-10.png"
                alt="我的代办"
                class="icon-img"
              />
            </div>
            <div class="function-badge">13</div>
            <div class="function-label">我的代办</div>
          </div>
          <div
            class="function-item"
            @click="navigateToPage('/customer-birthday')"
            style="cursor: pointer"
          >
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-11.png"
                alt="客户生日"
                class="icon-img"
              />
            </div>
            <div class="function-label">客户生日</div>
          </div>
        </div>
      </div>

      <!-- 服务区域 -->
      <div class="function-section">
        <div class="section-header">
          <span class="section-title">服务</span>
        </div>
        <div class="function-grid">
          <div class="function-item" @click="navigateToPage('/store_shop_list')">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-12.png"
                alt="门店进货"
                class="icon-img"
              />
            </div>
            <div class="function-label">门店进货</div>
          </div>
          <div class="function-item" @click="navigateToPage('/myTeam')">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-13.png"
                alt="我的团队"
                class="icon-img"
              />
            </div>
            <div class="function-label">我的团队</div>
          </div>
          <div
            class="function-item"
            @click="navigateToPage('/transformCustomer')"
          >
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-14.png"
                alt="客户转移"
                class="icon-img"
              />
            </div>
            <div class="function-label">客户转移</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-15.png"
                alt="今日关账"
                class="icon-img"
              />
            </div>
            <div class="function-label">今日关账</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-16.png"
                alt="积分核销"
                class="icon-img"
              />
            </div>
            <div class="function-label">积分核销</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-17.png"
                alt="券核销"
                class="icon-img"
              />
            </div>
            <div class="function-label">券核销</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img
                src="../assets/img/home/ico-18.png"
                alt="商品"
                class="icon-img"
              />
            </div>
            <div class="function-label">商品</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { onMounted, onBeforeMount, ref } from "vue";
import userShopInfo from "@/components/usershopinfo.vue";
import authApi from "@/utils/api/auth";

const router = useRouter();

const navigateToPage = (path) => {
  router.push(path);
};

const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};

//是否有权限
const roledata = true;

// 新增响应式变量存储用户信息和部门数据，用于传递给子组件
const weComUserInfo = ref({});
const departmentdata = ref({});

onBeforeMount(() => {
  // localStorage.setItem('token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXkiOiI3OTE0OTA3Nzc1NDgzMzMwNTYiLCJzdWIiOiJ1c2VyIiwiZXhwIjoxNzczNjU2ODY2LCJpYXQiOjE3NzM2MjgwNjZ9.Zj-3X0ZK8zipiXV5fjoro5HPLc0jpppi9bZ4BcyzhRI')
  // localStorage.setItem("weComUserInfo", JSON.stringify({"id":5,"created_at":"2025-12-24 10:21:47","updated_at":"2026-03-13 14:44:03","uuid":"791490777548333056","firm_uuid":6,"session_key":"","openid":"","phone":"15129431397","avatar_url":"https://wework.qpic.cn/wwpic3az/935197_llDHAJ1ETvGZkLb_1764034154/0","nick_name":"","union_id":"","status":1,"shop_clerk_uuid":"791499374961369088","user_id":"GuoZhiHao","qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc952a6c6aa0a6eafe","address":"上海市上海市杨浦区创业环路","gender":1,"shop_clerk_info":{"id":17,"created_at":"2025-12-24 10:55:56","updated_at":"2025-12-24 10:55:56","uuid":"791499374961369088","firm_uuid":6,"phone":"15129431397","name":"郭志豪","status":1,"is_admin":1,"admin":null,"wx_shop_info":null,"shop_clerk_positions":null,"is_anchor":2}}));
  // localStorage.setItem("userInfo", JSON.stringify({"userid":"GuoZhiHao","mobile":"15129431397","gender":"1","avatar":"https://wework.qpic.cn/wwpic3az/935197_llDHAJ1ETvGZkLb_1764034154/0"}));
  // localStorage.setItem("shop_clerk_uuid", '791499374961369088');
  // localStorage.setItem("departmentdata", JSON.stringify({"department_uuid":1406068854,"department_name":"测试门店","position_name":"店长"}));
  //是否登录
  const token = localStorage.getItem("token");
  if (!token) {
    router.replace({ path: "/login" });
    return;
  }
  //获取用户信息
  getUserInfo();
  //获取部门列表
  const storedDepartmentData =
    JSON.parse(localStorage.getItem("departmentdata")) || {};
  if (storedDepartmentData.department_uuid) {
    departmentdata.value = storedDepartmentData;
  } else {
    getDepartmentList();
  }
});

const getUserInfo = async () => {
  try {
    const response = await authApi.getUserInfo();
    if (response.code === 200) {
      weComUserInfo.value = response.data.wx_shop_info;
      localStorage.setItem(
        "weComUserInfo",
        JSON.stringify(response.data.wx_shop_info),
      );
    }
  } catch (error) {
    console.error("获取用户信息失败:", error);
  }
};

const getDepartmentList = async () => {
  try {
    const response = await authApi.myDepartments();
    if (response.code === 200) {
      // 假设 response.data 是一个数组，我们遍历它
      let data = response.data[0];
      const newDepartmentData = {
        department_uuid: data.department_uuid,
        department_name: data.department.name,
        department_type: data.department.type,
        position_name: data.position.name,
        position_uuid: data.position.uuid,
        shop_name: data.department.shop.name,
        shop_address: data.department.shop.address,
    }
      departmentdata.value = newDepartmentData;
      localStorage.setItem("departmentdata", JSON.stringify(newDepartmentData));
    }
  } catch (error) {
    console.error("获取部门列表失败:", error);
  }
}
import * as ww from '@wecom/jssdk'

initWeWorkConfig()
async function initWeWorkConfig() {
  ww.register({
    corpId: import.meta.env.VITE_WECOM_CORPID,       // 必填
    agentId: import.meta.env.VITE_WECOM_AGENTID,                  // 必填，当前应用的 AgentID
    jsApiList: ['launchMiniprogram', 'scanQRCode'], // 必填
    // 获取“企业签名”的回调
    getConfigSignature: async (url) => {
      // 这里的 url 是 SDK 自动传给你的，不要手动用 window.location.href
      const res = await authApi.getsignature(url);
      return {
        timestamp: res.data.timestamp,
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
      };
    },

    // 获取“应用签名”的回调（跳转小程序必须有这个）
    getAgentConfigSignature: async (url) => {
      // 注意：这里的后端接口必须使用应用的 jsapi_ticket 来生成签名
      // 很多时候后端会把两个签名放在一个接口返回，也可以分两个接口
      const res = await authApi.getAgentSignature(url);
      return {
        timestamp: res.data.timestamp,
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
      };
    },
  });
}
//代客下单跳转到小程序
const openwxminapp = async () => {
  const targetUrl = window.location.origin + '/orderlist?order_type=1';
  window.history.replaceState(null, '', targetUrl);
  //跳转微信小程序
  ww.launchMiniprogram({
    appid: import.meta.env.VITE_WX_MINI_APPID,
    path: 'pages/goods/goodslist?proxy=1&name=流行性&phone=15129431397&uuid=816964263339106304&user=816964263339106304',
    envVersion: 'release',//release 正式版，trial 体验版，developer 开发版
    success: function (res) {
      console.log('launchMiniprogram success', res)
    },
    fail: function (res) {
      console.log('launchMiniprogram fail', res)
    }
  })
}
</script>

<style lang="less" scoped>
.workbench-container {
  min-height: 100vh;
  padding-bottom: 70px;
  position: relative;
  font-family: "PingFang SC-Heavy";
}

/* 顶部背景 */
.top-background {
  position: relative;
  overflow: hidden;
  padding-bottom: 31px;

  .background-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    object-fit: cover;
  }

  /* 数据概览区域 */
  .data-overview {
    display: flex;
    background-color: #fff;
    padding: 14px 0;
    margin: 0 auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    width: 346px;
    height: 80px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 11px;
    overflow: hidden;
    border-image: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      )
      1 1;
    position: relative;

    .data-item {
      flex: 1;
      text-align: center;
      position: relative;

      &:not(:last-child)::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 40px;
        background-color: #eee;
      }

      .data-number {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin-bottom: 4px;
      }

      .data-label {
        font-size: 11px;
        color: #333;

        .data-label-text {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;

          .data-badge {
            position: absolute;
            background-color: #ff7123;
            border-radius: 7px;
            text-align: center;
            padding: 3px;
            top: 0px;
            right: 28px;
          }
        }
      }
    }
  }
}

.function-box {
  background-color: #fffcf7;
  padding: 12px 14px;
  border-radius: 25px 25px 0 0;
  margin-top: -19px;
  position: relative;

  .role_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 66px;

    img {
      width: 110px;
      height: 110px;
      margin-right: 8px;
      margin-bottom: 10px;
    }

    .function-label {
      font-size: 15px;
      color: #333;
      font-weight: 500;
    }
  }

  /* 功能区域 */
  .function-section {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 11px 13px 15px;
    border-radius: 11px;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 13px;

      .section-title {
        font-size: 19px;
        font-weight: 600;
        color: #333;
        position: relative;
        padding-left: 8px;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 13px;
          background: linear-gradient(180deg, #ff7123 0%, #ffb45b 100%);
          border-radius: 28px;
        }
      }

      .view-all {
        font-size: 15px;
        color: #666;

        .viwe-arrow {
          width: 13px;
          height: 13px;
        }
      }
    }

    .function-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px 10px;

      .function-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .function-icon {
          width: 27px;
          height: 27px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 5px;

          .icon-img {
            width: 28px;
            height: 28px;
          }
        }

        .function-badge {
          position: absolute;
          top: -15px;
          right: 9px;
          background-color: #ff7123;
          color: #fff;
          font-size: 12px;
          border-radius: 19px;
          min-width: 19px;
          line-height: 19px;
          text-align: center;
        }

        .function-label {
          font-size: 15px;
          color: #333;
          text-align: center;
        }
      }
    }

    .transaction-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

/* 底部空间 */
.bottom-space {
  height: 85px;
}
</style>
